/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type BrokenHreflangIssuesRow_issue$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type BrokenHreflangIssuesTable_project$ref: FragmentReference;
export type BrokenHreflangIssuesTable_project = {|
  +host: string,
  +crawls: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +brokenHreflangs: ?{|
          +count: number,
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +$fragmentRefs: BrokenHreflangIssuesRow_issue$ref
            |}
          |}>,
        |}
      |}
    |}>
  |},
  +$refType: BrokenHreflangIssuesTable_project$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "operator": "AND",
  "values": ([]/*: any*/)
};
return {
  "kind": "Fragment",
  "name": "BrokenHreflangIssuesTable_project",
  "type": "Project",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "offset",
      "type": "Int",
      "defaultValue": 0
    },
    {
      "kind": "LocalArgument",
      "name": "limit",
      "type": "Int",
      "defaultValue": 20
    },
    {
      "kind": "LocalArgument",
      "name": "url",
      "type": "TextFilters",
      "defaultValue": v0
    },
    {
      "kind": "LocalArgument",
      "name": "sourceUrl",
      "type": "TextFilters",
      "defaultValue": v0
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "host",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "crawls",
      "storageKey": "crawls(limit:1,offset:0)",
      "args": [
        {
          "kind": "Literal",
          "name": "limit",
          "value": 1,
          "type": "Int"
        },
        {
          "kind": "Literal",
          "name": "offset",
          "value": 0,
          "type": "Int"
        }
      ],
      "concreteType": "CrawlsConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "CrawlsEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Crawl",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "brokenHreflangs",
                  "storageKey": null,
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "limit",
                      "variableName": "limit",
                      "type": "Int"
                    },
                    {
                      "kind": "Variable",
                      "name": "offset",
                      "variableName": "offset",
                      "type": "Int"
                    },
                    {
                      "kind": "Variable",
                      "name": "sourceUrl",
                      "variableName": "sourceUrl",
                      "type": "TextFilters"
                    },
                    {
                      "kind": "Variable",
                      "name": "url",
                      "variableName": "url",
                      "type": "TextFilters"
                    }
                  ],
                  "concreteType": "BrokenHreflangConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "count",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "BrokenHreflangEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "BrokenHreflang",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "FragmentSpread",
                              "name": "BrokenHreflangIssuesRow_issue",
                              "args": null
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '0f58995cc8f0736d3bb6f51b04ef8e02';
module.exports = node;
